import React from 'react';
import styled from 'styled-components';
//import { defaultTheme } from '../../data/themes';

const defaultTheme = {};

const BoxWrapper = styled.div`
	width: ${props => props.width};
	margin: ${props => props.margin};
	max-width: ${props => props.maxWidth};
	height: ${props => props.height};
	max-height: ${props => props.maxHeight};
	border: ${props => props.theme.boxBorder || defaultTheme.boxBorder};
	border-radius: ${props => props.theme.boxBorderRadius || defaultTheme.boxBorderRadius};
	padding: ${props => props.boxPadding || props.theme.boxPadding || defaultTheme.boxPadding};
	background: ${props => props.theme.boxBackground || defaultTheme.boxBackground};
	&.inactive {
		opacity: 0.4;
	}
`;

const Header = styled.div`
	position: relative;
	text-align: center;
	border-bottom: ${props => props.theme.boxHeaderBottomBorder || defaultTheme.boxHeaderBottomBorder};
	white-space: nowrap;
	overflow: hidden;

	color: ${props => props.theme.boxHeaderColor || defaultTheme.boxHeaderColor};
	background: ${props => props.theme.boxHeaderBackground || defaultTheme.boxHeaderBackground};

	font-size: ${props => props.theme.boxHeaderFontSize || defaultTheme.boxHeaderFontSize};
	font-weight: ${props => props.theme.boxHeaderFontWeight || defaultTheme.boxHeaderFontWeight};
	padding: ${props => props.padding || props.theme.boxHeaderPadding || defaultTheme.boxHeaderPadding};
	margin: ${props => props.theme.boxHeaderMargin || defaultTheme.boxHeaderMargin};


`;

const RightHeaderContent = styled.div`
	position: relative;
	float: right;
`;

const LeftHeaderContent = styled.div`
	position: relative;
	float: left;
`;


const Content = styled.div`
	padding: ${props => props.padding};
	background: ${props => props.theme.boxContentBackground || defaultTheme.boxContentBackground};
	width: ${props => props.width};
	max-width: ${props => props.maxWidth};
	height: ${props => props.height};
	max-height: ${props => props.maxHeight};
`;

export default class Box extends React.Component {
	render() {
		return (
			<BoxWrapper
				width={this.props.width}
				margin={this.props.margin}
				maxWidth={this.props.maxWidth}
				height={this.props.height}
				maxHeight={this.props.maxHeight}
				boxPadding={this.props.boxPadding}
				className={(this.props.inactive ? 'inactive ' : '') + (this.props.className || '')}
			>
				{
					this.props.header && (
						<Header padding={this.props.headerPadding}>
							{
								this.props.leftHeaderContent && (
									<LeftHeaderContent>
										{this.props.leftHeaderContent}
									</LeftHeaderContent>
								)
							}
							{this.props.header}
							{
								this.props.rightHeaderContent && (
									<RightHeaderContent>
										{this.props.rightHeaderContent}
									</RightHeaderContent>
								)
							}
						</Header>
					)
				}
				<Content
					padding={this.props.padding}
					width={this.props.contentWidth}
					maxWidth={this.props.maxContentWidth}
					height={this.props.contentHeight}
					maxHeight={this.props.maxContentHeight}
				>
					{this.props.children}
				</Content>
			</BoxWrapper>
		);
	}
}
